import { shift_pressed } from '@frontend/keypress';
import { hide_modal, show_modal } from '@frontend/modals';
import { uid_end_scale_objects, uid_hide_rigid_move_manipulator, uid_scale_objects, uid_start_scale_objects } from '@frontend/ui_display';
import { uil_get_edges_of_face, uil_get_edges_of_vertex, uil_get_vertices_of_edge, uil_is_object_fixed, uil_move_vertex_to_coords } from '@frontend/ui_logic';
import { get_display_unit_from_unitless_value, get_number, suppress_undo_tracking, unsuppress_undo_tracking_if_ready } from '@frontend/utility';
import { approximately_coaxial, point_point_distance } from '@frontend/vector3';
import { Edge, Vertex } from '@phi/jcore';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { Vector3 } from 'three';
import { $ } from '@vaaas/fpts/dom';
import App from '@frontend/application-container';

export * from './modal';

export function display_scale_modal(only_this_coordinate = '') {
    function on_error() {
        display_message_to_user(LOG.WARN, 'Cannot scale set affecting fixed objects.');
    }

    if (only_this_coordinate == '' && uid_rigid_move_manipulator && uid_rigid_move_manipulator.is_shown)
        uid_hide_rigid_move_manipulator(false, 0, true);

    // First check that no fixed objects are involved, directly or indirectly
    const edges: Set<Edge> = new Set();

    for (const f of uid_selected_faces.keys()) {
        if (uil_is_object_fixed(f))
            return on_error();
        for (const e of uil_get_edges_of_face(f))
            edges.add(e);
    }

    for (const x of uid_selected_edges.keys())
        edges.add(x);

    for (const eid of edges)
        if (uil_is_object_fixed(eid))
            return on_error();


    const hanging_edges: Edge[] = [];
    for (const eid of edges)
        for (const vid of uil_get_vertices_of_edge(eid))
            for (const eid of uil_get_edges_of_vertex(vid))
                hanging_edges.push(eid);
    for (const x of hanging_edges)
        edges.add(x);

    for (const eid of edges)
        if (uil_is_object_fixed(eid))
            return on_error();

    // Set css classes and variables controlling appearance
    if (uid_selected_vertices.keys().length > 0)
        document.getElementById('scaleModal')!.dataset.showLockVertex = 'true';
    else
        document.getElementById('scaleModal')!.dataset.showLockVertex = 'false';
    if (uid_selected_vertices.keys().length == 2)
        document.getElementById('scaleModal')!.dataset.showDistanceValues = 'true';
    else
        document.getElementById('scaleModal')!.dataset.showDistanceValues = 'false';

    scale_modal_display_current_values();

    // Attach event handler to textboxes and checkboxes
    ($('#scale-percentage-d') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-percentage-d') as HTMLInputElement), 'd_percent_text');
        ($('#modelProportionally') as HTMLInputElement).checked = true;
    };

    ($('#scale-percentage-x') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-percentage-x') as HTMLInputElement), 'x_percent_text');
    };
    ($('#scale-percentage-y') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-percentage-y') as HTMLInputElement), 'y_percent_text');
    };
    ($('#scale-percentage-z') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-percentage-z') as HTMLInputElement), 'z_percent_text');
    };

    ($('#scale-d-new-distance-text') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-d-new-distance-text') as HTMLInputElement), 'd_distance_text');
        ($('#modelProportionally') as HTMLInputElement).checked = true;
    };
    ($('#scale-x-new-distance-text') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-x-new-distance-text') as HTMLInputElement), 'x_distance_text');
    };
    ($('#scale-y-new-distance-text') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-y-new-distance-text') as HTMLInputElement), 'y_distance_text');
    };
    ($('#scale-z-new-distance-text') as HTMLInputElement).onchange = function () {
        update_scale_modal_values(get_number($('#scale-z-new-distance-text') as HTMLInputElement), 'z_distance_text');
    };

    ($('#modelProportionally') as HTMLInputElement).onchange = rescale_proportionately_changed;

    ($('#scale-percentage-d') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-percentage-d') as HTMLInputElement), 'd_percent_text');
        ($('#modelProportionally') as HTMLInputElement).checked = true;
    };
    ($('#scale-percentage-x') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-percentage-x') as HTMLInputElement), 'x_percent_text');
    };
    ($('#scale-percentage-y') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-percentage-y') as HTMLInputElement), 'y_percent_text');
    };
    ($('#scale-percentage-z') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-percentage-z') as HTMLInputElement), 'z_percent_text');
    };

    ($('#scale-d-new-distance-text') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-d-new-distance-text') as HTMLInputElement), 'd_distance_text');
        ($('#modelProportionally') as HTMLInputElement).checked = true;
    };
    ($('#scale-x-new-distance-text') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-x-new-distance-text') as HTMLInputElement), 'x_distance_text');
    };
    ($('#scale-y-new-distance-text') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-y-new-distance-text') as HTMLInputElement), 'y_distance_text');
    };
    ($('#scale-z-new-distance-text') as HTMLInputElement).onblur = function () {
        update_scale_modal_values(get_number($('#scale-z-new-distance-text') as HTMLInputElement), 'z_distance_text');
    };

    // Show modal
    suppress_undo_tracking();

    // Check whether we want to suppress all but one coordinate, and also the image guide

    document.getElementById('rescale_model_guide_png')!.hidden = false;
    document.getElementById('scale-table_d_row')!.hidden = false;
    document.getElementById('scale-table_x_row')!.hidden = false;
    document.getElementById('scale-table_y_row')!.hidden = false;
    document.getElementById('scale-table_z_row')!.hidden = false;
    document.getElementById('scale-table_x_label')!.hidden = false;
    document.getElementById('scale-table_y_label')!.hidden = false;
    document.getElementById('scale-table_z_label')!.hidden = false;
    if (only_this_coordinate != '') {
      document.getElementById('scale-table_x_label')!.hidden = true;
      document.getElementById('scale-table_y_label')!.hidden = true;
      document.getElementById('scale-table_z_label')!.hidden = true;
      document.getElementById('rescale_model_guide_png')!.hidden = true;
      document.getElementById('scale-table_d_row')!.hidden = true;
      document.getElementById('scale-table_x_row')!.hidden = true;
      document.getElementById('scale-table_y_row')!.hidden = true;
      document.getElementById('scale-table_z_row')!.hidden = true;
      if (only_this_coordinate == 'x')
        document.getElementById('scale-table_x_row')!.hidden = false;
      if (only_this_coordinate == 'y')
        document.getElementById('scale-table_y_row')!.hidden = false;
      if (only_this_coordinate == 'z')
        document.getElementById('scale-table_z_row')!.hidden = false;
      if (shift_pressed())
        document.getElementById('scale-table_d_row')!.hidden = false;
    }
    show_modal('scaleModal');
}

export function scale_modal_display_current_values() {
    // Set initial values for textboxes
    ($('#scale-percentage-d') as HTMLInputElement).valueAsNumber = 100;
    ($('#scale-percentage-x') as HTMLInputElement).valueAsNumber = 100;
    ($('#scale-percentage-y') as HTMLInputElement).valueAsNumber = 100;
    ($('#scale-percentage-z') as HTMLInputElement).valueAsNumber = 100;

    if (uid_selected_vertices.keys().length > 1) {
        const v1 = uid_selected_vertices.getItemAtIndex(0);
        const v2 = uid_selected_vertices.getItemAtIndex(1);
        const v1p = v1!.object3d!.position;
        const v2p = v2!.object3d!.position;
        const v1px = new Vector3(v1p.x, 0, 0);
        const v2px = new Vector3(v2p.x, 0, 0);
        const v1py = new Vector3(0, v1p.y, 0);
        const v2py = new Vector3(0, v2p.y, 0);
        const v1pz = new Vector3(0, 0, v1p.z);
        const v2pz = new Vector3(0, 0, v2p.z);

        let distDiag = point_point_distance(v1p, v2p);
        let distx = point_point_distance(v1px, v2px);
        let disty = point_point_distance(v1py, v2py);
        let distz = point_point_distance(v1pz, v2pz);

        distDiag = get_display_unit_from_unitless_value(distDiag);
        distx = get_display_unit_from_unitless_value(distx);
        disty = get_display_unit_from_unitless_value(disty);
        distz = get_display_unit_from_unitless_value(distz);

        const strDiag = distDiag.toFixed(6);
        const strx = distx.toFixed(App.settings.coordinate_decimals);
        const stry = disty.toFixed(App.settings.coordinate_decimals);
        const strz = distz.toFixed(App.settings.coordinate_decimals);

        ($('#scale-d-current-distance-text') as HTMLInputElement).value = Number(strDiag).toFixed(App.settings.coordinate_decimals);
        ($('#scale-x-current-distance-text') as HTMLInputElement).value = Number(strx).toFixed(App.settings.coordinate_decimals);
        ($('#scale-y-current-distance-text') as HTMLInputElement).value = Number(stry).toFixed(App.settings.coordinate_decimals);
        ($('#scale-z-current-distance-text') as HTMLInputElement).value = Number(strz).toFixed(App.settings.coordinate_decimals);
        ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(strDiag).toFixed(App.settings.coordinate_decimals);
        ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(strx).toFixed(App.settings.coordinate_decimals);
        ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(stry).toFixed(App.settings.coordinate_decimals);
        ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(strz).toFixed(App.settings.coordinate_decimals);
        ($('#scale_unit_current') as HTMLDivElement).innerHTML = App.state.display_units;
        ($('#scale_unit_new') as HTMLDivElement).innerHTML = App.state.display_units;
    }
}

type UpdateScaleEvent =
    'd_percent_text'
    | 'x_percent_text'
    | 'y_percent_text'
    | 'z_percent_text'
    | 'd_distance_text'
    | 'x_distance_text'
    | 'y_distance_text'
    | 'z_distance_text';

export function update_scale_modal_values(value: number, event_string: UpdateScaleEvent) {
    const show_distance_values = uid_selected_vertices.keys().length >= 2 ? true : false;
    const scale_d_current_distance_text = get_number($('#scale-d-current-distance-text') as HTMLInputElement);
    const scale_x_current_distance_text = get_number($('#scale-x-current-distance-text') as HTMLInputElement);
    const scale_y_current_distance_text = get_number($('#scale-y-current-distance-text') as HTMLInputElement);
    const scale_z_current_distance_text = get_number($('#scale-z-current-distance-text') as HTMLInputElement);

    switch (event_string) {
        case 'd_percent_text':
            ($('#scale-percentage-x') as HTMLInputElement).value = (Number(value).toFixed(3));
            ($('#scale-percentage-y') as HTMLInputElement).value = (Number(value).toFixed(3));
            ($('#scale-percentage-z') as HTMLInputElement).value = (Number(value).toFixed(3));
            if (show_distance_values) {
                ($('#scale-d-new-distance-text') as HTMLInputElement).value = (Number(scale_d_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals));
                ($('#scale-x-new-distance-text') as HTMLInputElement).value = (Number(scale_x_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals));
                ($('#scale-y-new-distance-text') as HTMLInputElement).value = (Number(scale_y_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals));
                ($('#scale-z-new-distance-text') as HTMLInputElement).value = (Number(scale_z_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals));
            }
            break;

        case 'x_percent_text':
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-y') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-z') as HTMLInputElement).value = Number(value).toFixed(3);
            }
            if (show_distance_values) {
                ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                if (rescale_proportionally()) {
                    ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_z_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                }
            }
            break;

        case 'y_percent_text':
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-x') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-z') as HTMLInputElement).value = Number(value).toFixed(3);
            }
            if (show_distance_values) {
                ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                if (rescale_proportionally()) {
                    ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_z_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                }
            }
            break;

        case 'z_percent_text':
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-x') as HTMLInputElement).value = Number(value).toFixed(3);
                ($('#scale-percentage-y') as HTMLInputElement).value = Number(value).toFixed(3);
            }
            if (show_distance_values) {
                ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                if (rescale_proportionally()) {
                    ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                    ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * value/100).toFixed(App.settings.coordinate_decimals);
                }
            }
            break;

        case 'd_distance_text': {
            const p = value/scale_d_current_distance_text;
            ($('#scale-percentage-d') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            ($('#scale-percentage-x') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            ($('#scale-percentage-y') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            ($('#scale-percentage-z') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_z_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            break;
        }

        case 'x_distance_text': {
            const p = value/scale_x_current_distance_text;
            ($('#scale-percentage-x') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-y') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-z') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_z_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            }
            break;
        }

        case 'y_distance_text': {
            const p = value/scale_y_current_distance_text;
            ($('#scale-percentage-y') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-x') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-z') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-z-new-distance-text') as HTMLInputElement).value = Number(scale_z_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            }
            break;
        }

        case 'z_distance_text': {
            const p = value/scale_z_current_distance_text;
            ($('#scale-percentage-z') as HTMLInputElement).value = Number(p * 100).toFixed(3);
            if (rescale_proportionally()) {
                ($('#scale-percentage-d') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-x') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-percentage-y') as HTMLInputElement).value = Number(p * 100).toFixed(3);
                ($('#scale-d-new-distance-text') as HTMLInputElement).value = Number(scale_d_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-x-new-distance-text') as HTMLInputElement).value = Number(scale_x_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
                ($('#scale-y-new-distance-text') as HTMLInputElement).value = Number(scale_y_current_distance_text * p).toFixed(App.settings.coordinate_decimals);
            }
            break;
        }
    }
}


export function execute_scale() {
    // If we only have 2 vertices selected, we will use the set_vertex_distance API call instead of the scale_edge_list API call.
    let execute_vertex_distance = false;
    if (uid_selected_vertices.length == 2 && uid_selected_edges.length == 0 && uid_selected_faces.length == 0)
        execute_vertex_distance = true;

    let factor;
    let axis;

    // Identify the axis of the scale

    // There are two possibilities: Either the user has clicked on the Scale button at the top of the screen, in which case
    // the rigid move manipulator is not displayed, or they clicked on one of the three balls of the rigid move manipulator
    // We handle them independently, because in the first case the X, Y, and Z scale axis directions are clear, whereas in the
    // second case they depend on the placement of the manipulator.

    let scale_percentage_d = 100;
    let scale_percentage_x = 100;
    let scale_percentage_y = 100;
    let scale_percentage_z = 100;
    let should_rescale_proportionally = false;

    if (uid_rigid_move_manipulator && uid_rigid_move_manipulator.is_shown) {
        uid_rigid_move_manipulator.set_has_operated();

        should_rescale_proportionally = rescale_proportionally();

        const vx = new Vector3(1, 0, 0);
        const vy = new Vector3(0, 1, 0);
        const vz = new Vector3(0, 0, 1);
        // Inentify the direction of the axis that was clicked
        const ax = get_number($('#scale-percentage-x') as HTMLInputElement);
        const ay = get_number($('#scale-percentage-y') as HTMLInputElement);
        const az = get_number($('#scale-percentage-z') as HTMLInputElement);

        const clicked_axis = new Vector3(1, 0, 0);
        let clicked_factor = 100;
        const local_epsilon = 1e-4;

        if (ax != 100) {
            clicked_axis.copy(uid_rigid_move_manipulator.local_x_direction);
            clicked_factor = get_number($('#scale-percentage-x') as HTMLInputElement);
        } else if (ay != 100) {
            clicked_axis.copy(uid_rigid_move_manipulator.local_y_direction);
            clicked_factor = get_number($('#scale-percentage-y') as HTMLInputElement);
        } else if (az != 100) {
            clicked_axis.copy(uid_rigid_move_manipulator.local_z_direction);
            clicked_factor = get_number($('#scale-percentage-z') as HTMLInputElement);
        }

        if (
            approximately_coaxial(clicked_axis, vx, local_epsilon)
            || approximately_coaxial(clicked_axis, vy, local_epsilon)
            || approximately_coaxial(clicked_axis, vz, local_epsilon)
        ) {
            // Vector is aligned
            if (approximately_coaxial(clicked_axis, vx, local_epsilon))
                scale_percentage_x = clicked_factor;
            else if (approximately_coaxial(clicked_axis, vy, local_epsilon))
                scale_percentage_y = clicked_factor;
            else if (approximately_coaxial(clicked_axis, vz, local_epsilon))
                scale_percentage_z = clicked_factor;
            if (should_rescale_proportionally)
                scale_percentage_d = clicked_factor;
        } else {
            display_message_to_user(LOG.WARN, 'The scaling is proportional, because the scale direction is not aligned with the X, Y or Z axis. Temporary limitation');
            should_rescale_proportionally = true;
            scale_percentage_d = clicked_factor;
        }
    } else {
        scale_percentage_d = get_number($('#scale-percentage-d') as HTMLInputElement);
        scale_percentage_x = get_number($('#scale-percentage-x') as HTMLInputElement);
        scale_percentage_y = get_number($('#scale-percentage-y') as HTMLInputElement);
        scale_percentage_z = get_number($('#scale-percentage-z') as HTMLInputElement);
        should_rescale_proportionally = rescale_proportionally();
    }

    suppress_undo_tracking();

    // Simply execute the scale operation
    if (!execute_vertex_distance) {
        uid_start_scale_objects(lock_1st_vertex());
        if (should_rescale_proportionally) {
            factor = scale_percentage_d/100;
            uid_scale_objects(factor, null, lock_1st_vertex());
        } else {
            factor = scale_percentage_x/100;
            axis = new Vector3(1, 0, 0);
            uid_scale_objects(factor, axis, lock_1st_vertex());
            factor = scale_percentage_y/100;
            axis = new Vector3(0, 1, 0);
            uid_scale_objects(factor, axis, lock_1st_vertex());
            factor = scale_percentage_z/100;
            axis = new Vector3(0, 0, 1);
            uid_scale_objects(factor, axis, lock_1st_vertex());
        }
        uid_end_scale_objects();
    } else {
        factor = scale_percentage_d/100;
        if (factor != 1) {
            // A non-unit scale factor is given for the diagonal, so we only consider this one
            const v1 = uid_selected_vertices.getKeyAtIndex(0)!;
            const v2 = uid_selected_vertices.getKeyAtIndex(1)!;
            move_pair_of_vertices_for_scaling(v1, v2, factor, 'd', lock_1st_vertex());
        } else {
            // Independently scale along x, y, and z
            factor = scale_percentage_x/100;
            if (factor != 1) {
                const v1 = uid_selected_vertices.getKeyAtIndex(0)!;
                const v2 = uid_selected_vertices.getKeyAtIndex(1)!;
                move_pair_of_vertices_for_scaling(v1, v2, factor, 'x', lock_1st_vertex());
            }
            factor = scale_percentage_y/100;
            if (factor != 1) {
                const v1 = uid_selected_vertices.getKeyAtIndex(0)!;
                const v2 = uid_selected_vertices.getKeyAtIndex(1)!;
                move_pair_of_vertices_for_scaling(v1, v2, factor, 'y', lock_1st_vertex());
            }
            factor = scale_percentage_z/100;
            if (factor != 1) {
                const v1 = uid_selected_vertices.getKeyAtIndex(0)!;
                const v2 = uid_selected_vertices.getKeyAtIndex(1)!;
                move_pair_of_vertices_for_scaling(v1, v2, factor, 'z', lock_1st_vertex());
            }
        }
    }

    unsuppress_undo_tracking_if_ready(false);

    // Update with the new current values.
    scale_modal_display_current_values();
    hide_modal('scaleModal');
}

export function rescale_proportionately_changed() {
    if (rescale_proportionally())
        update_scale_modal_values(get_number($('#scale-percentage-d') as HTMLInputElement), 'd_percent_text');
}

export function rescale_proportionally() {
    const elem = $('#modelProportionally');
    if (elem instanceof HTMLInputElement)
        return elem.checked;
    else
        return false;
}

export function lock_1st_vertex() {
    const elem = $('#lockFirstSelected');
    if (elem instanceof HTMLInputElement)
        return elem.checked;
    else
        return false;
}

export function move_pair_of_vertices_for_scaling(v1id: Vertex, v2id: Vertex, factor: number, axis: 'd' | 'x' | 'y' | 'z', lock_1st_vertex: boolean) {
    const v1 = uid_vertices.getItem(v1id);
    const v2 = uid_vertices.getItem(v2id);
    const v1current = new Vector3();
    const v2current = new Vector3();
    const v1new = new Vector3();
    const v2new = new Vector3();
    v1current.copy(v1!.object3d!.position);
    v2current.copy(v2!.object3d!.position);
    const dx = (v2current.x-v1current.x) * (1-factor);
    const dy = (v2current.y-v1current.y) * (1-factor);
    const dz = (v2current.z-v1current.z) * (1-factor);
    if (lock_1st_vertex) {
        v1new.copy(v1current);
        v2new.copy(v2current);
        if (axis == 'd' || axis == 'x')
            v2new.x = v2current.x - dx;
        if (axis == 'd' || axis == 'y')
            v2new.y = v2current.y - dy;
        if (axis == 'd' || axis == 'z')
            v2new.z = v2current.z - dz;
        uil_move_vertex_to_coords(v2id, v2new.x, v2new.y, v2new.z);
    } else {
        v1new.copy(v1current);
        v2new.copy(v2current);
        if (axis == 'd' || axis == 'x') {
            v1new.x = v1current.x + dx/2;
            v2new.x = v2current.x - dx/2;
        }
        if (axis == 'd' || axis == 'y'){
            v1new.y = v1current.y + dy/2;
            v2new.y = v2current.y - dy/2;
        }
        if (axis == 'd' || axis == 'z') {
            v1new.z = v1current.z + dz/2;
            v2new.z = v2current.z - dz/2;
        }
        uil_move_vertex_to_coords(v1id, v1new.x, v1new.y, v1new.z);
        uil_move_vertex_to_coords(v2id, v2new.x, v2new.y, v2new.z);
    }
}
